import Reveal from '../../../shared/Reveal/Reveal';
import { useInfrastructureNeverStaticContent } from '../../../../hooks/useInfrastructureNeverStaticContent';
import './NeverStatic.css';

const NeverStatic = () => {
  const { content, isLoading } = useInfrastructureNeverStaticContent();

  if (isLoading || !content) {
    return null;
  }

  return (
    <section className="infrastructure-never-static">
      <div className="infrastructure-never-static__inner">
        <Reveal as="blockquote" className="infrastructure-never-static__quote">
          {content.quote}
        </Reveal>
      </div>
    </section>
  );
};

export default NeverStatic;
